import MobileMarketplaceLink from './MobileMarketplaceLink';
export default MobileMarketplaceLink;
